import _ from 'underscore'

function AutoQueryFactory($localStorage, $q, $timeout, $rootScope, $parse, createServiceBus) {
    class AutoQueryLegacy {
        constructor(url, options) {
            var me = this;
            if (angular.isString(url)) options = angular.extend({ url }, options);
            else if (angular.isObject(url)) options = angular.extend(url, options);

            //console.log('AutoQueryLegacy', options);
            angular.extend(me, {
                bus: createServiceBus(),
                commands: {},
                pageSizes: [12,24,48,72,96],
                results: [],
                append: false,
                calls: 0,
                total: 0,
                page: 1,
                criteria: {},
                sortOptions: {},
                debounce: 250,
            },
            options,
            {
                orderBy: $localStorage[options.url + ':OrderBy'] || options.orderBy || '',
                pageSize: $localStorage[options.url + ':PageSize'] || options.pageSize || options.take || 30,
                groupSize: $localStorage[options.url + ':GroupSize'] || options.groupSize || 0
            });
            //console.log('AutoQueryLegacy angular.extend(me', me);
            //console.warn('me.orderBy', me.orderBy);

            //promises
            ['loading', 'loaded', 'failed', 'empty'].forEach(k => {
                me[k] = $q.defer();
                me[k].on = me[k].subscribe = me[k].sub = cb => me[k].promise.finally(null, cb);
            });

            if (options.autoLoad) me.load();

            //listeners
            $rootScope.$on('$onAuthenticated', me.load.bind(me, true));
            $rootScope.$on('$onLogout', me.load.bind(me, true));
        }

        load(clear, _token) {
            let me = this;

            if (me.isBusy() || (me._loadTimeout && (me._loadTimeout !== _token))) {
                console.warn('aq.wait', _token, me.url);
                $timeout.cancel(me._loadTimeout);
                var token = me._loadTimeout = $timeout(() => me.load(clear, token), me.debounce); // delay 250 ms
                return token;
            }
            //if (me.loading) return false;
            for (var k in me.criteria) if (me.criteria[k] === '') delete me.criteria[k];
            var request = angular.extend({
                fields: me.fields,
                orderBy: me.orderBy,
                skip: (me.page - 1) * me.pageSize,
                take: me.pageSize
            }, me.criteria);

            if (!me.preProcess.call(me, request, clear)) return false;
            me.loading.notify({ request, clear, calls: me.calls++ });

            me._busy = new Date();
            me._idle = false;
            return me.bus.send(me.url, request).then(
                response => {
                    let result = response.data
                    if (clear) {
                        angular.extend(me, result);
                    } else {
                        result.results.forEach(m => me.results.push(m));
                        me.total = result.total;
                    }
                    me.setGroupSize(me.groupSize);
                    let args = angular.extend({ request, response, clear, calls: me.calls, count: result.results.length }, result);
                    me.loaded.notify(args);
                    me.postProcess(request, response, clear);
                    if (!result.results.length) me.empty.notify(args);
                    return result;
                },
                response => {
                    me.results = [];
                    me.page = 1;
                    me.failed.notify({ request, response, clear, calls: me.calls });
                    me._failed = new Date();
                })
                .finally(() => {
                    me._idle = new Date();
                    me._busy = false;
                });
        }

        preProcess() { return true; }
        postProcess() { }
        isBusy() { return this.bus.activeCalls.length > 0; }
        isIdle() { return this.bus.activeCalls.length === 0; }
        isEmpty() { return this.bus.calls > 0 && this.bus.activeCalls.length === 0 && this.total === 0; }
        dispose() { return this.bus.dispose(); }
        filter(field, value) {
            $parse(field).assign(this.criteria, value);
            this.load(true);
        }
        search(value) {
            this.filter('search', value);
        }
        sort(orderBy) {
            console.debug('sort', orderBy, this.orderBy);
            this.orderBy = $localStorage[this.url + ':OrderBy'] = orderBy;
            this.load(true);
        }
        setOrderBy(orderBy) {
            this.sort(orderBy);
        }
        groupResults(groupSize) {
            return _.groupBy(this.results, function (val, index) {
                return Math.floor(index / groupSize);
            });
        }
        more() {
            var me = this;
            console.log('more', me);
            if (me.append && !me.isBusy() && me.results.length < me.total) {
                console.info('more', me);
                me.setPage(me.page + 1);
            }
        }
        setPageSize(pageSize) {
            $localStorage[this.url + ':PageSize'] = this.pageSize = parseInt(pageSize);
            this.load(!this.append);
        }
        setGroupSize(groupSize) {
            if ((this.groupSize = groupSize) > 0) {
                this.groupedResults = this.groupResults(this.groupSize);
            }
        }
        setPage(page) {
            this.page = page;
            this.load(!this.append);
        }
        resetPaging() {
            var me = this;
            me.results = [];
            me.page = 1;
            me.load(true || me.append);
        }
        pageInfo() {
            var me = this;
            var begin = ((me.page - 1) * me.pageSize);
            var end = begin + me.pageSize;
            return "Showing " + (begin + 1) + " - " + Math.min(end, me.total) + " of " + me.total;
        }
        setPageSize(pageSize) {
            var me = this;
            me.pageSize = $localStorage[me.url + 'PageSize'] = parseInt(pageSize);
        }
        pageCount() {
            var me = this;
            return !me.append && Math.ceil(me.total / me.pageSize);
        }
        linkDirective(scope, attr) {
            var me = this;
            attr.onLoading && me.loading.subscribe(args => $parse(attr.onLoading)(scope, args));
            attr.onLoaded && me.loaded.subscribe(args => $parse(attr.onLoaded)(scope, args));
            attr.onEmpty && me.empty.subscribe(args => $parse(attr.onEmpty)(scope, args));
            attr.onFailed && me.failed.subscribe(args => $parse(attr.onFailed)(scope, args));
            attr.first && me.loaded.subscribe(args => $parse(attr.first).assign(scope, args.results[0]));
            attr.last && me.loaded.subscribe(args => $parse(attr.last).assign(scope, args.results[args.results.length - 1]));
            attr.ngModel && $parse(attr.ngModel).assign(scope, me);
        }
    }

    return AutoQueryLegacy;
}

function AutoQueryDirectiveFactory(AutoQueryLegacy, $parse, $interpolate) {
    return {
        restrict: 'E',
        scope: false,
        link: function (scope, element, attr) {
            let options = angular.extend({ autoLoad: true, url: attr.url || attr.autoQueryUrl }, scope.$eval(attr.autoQueryOptions || attr.options));
            //options.interpolateUrl = () => $interpolate(options.rawUrl)(scope);
            //options.url = interpolateUrl();
            //console.log('AutoQueryDirectiveFactory', options);
            //console.log('scope.$eval(attr.autoQueryOptions || attr.options)', scope.$eval(attr.autoQueryOptions || attr.options));
            let query = new AutoQueryLegacy(options);
            //if (attr.url) query.interpolateUrl = () => {
            //    query.url = $interpolate()
            //}
            let fieldName = attr.ngModel || attr.autoQuery || 'query';
            query.linkDirective(scope, attr);
            $parse(fieldName).assign(scope, query);
        }
    }
}

export {AutoQueryFactory, AutoQueryDirectiveFactory};
